import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {ApiService} from '../services/api';
import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../services/user-context';
import {MatDialog, MatIconRegistry, MatSnackBar} from '@angular/material';
import {DOCUMENT, TitleCasePipe} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {DataStateChangeEvent, RowArgs, SelectionEvent} from '@progress/kendo-angular-grid';
import {State} from '@progress/kendo-data-query';
import {EventClickEvent, SchedulerEvent} from '@progress/kendo-angular-scheduler';
import * as moment from 'moment';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {UsersService} from '../accounts/detail/components/users/users.service';
import {AppointmentDialogComponent} from './appointment-dialog.component';

@Component({
  selector: 'app-appointment',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'appointment.template.html',
  styleUrls: [
    './appointment.style.scss'
  ]
})
export class AppointmentComponent implements OnInit, OnDestroy {
  client: any;
  account: any;
  location: any;
  appointments: any;
  now = new Date();
  schedulerDate: Date = new Date();
  eventSubject:Subject<SchedulerEvent> = new Subject<SchedulerEvent>();
  events: SchedulerEvent[] = [];
  schedulerSubject:BehaviorSubject<SchedulerEvent[]> = new BehaviorSubject<SchedulerEvent[]>([]);

  public appointmentsState: State = {
    skip: 0,
    take: 5
  };

  private selectedAppointment: RowArgs;


  constructor(@Inject(DOCUMENT) private document: Document,
              private route: ActivatedRoute,
              private router: Router,
              public userContext: UserContext,
              public usersService: UsersService,
              public dialog: MatDialog,
              private snackBar: MatSnackBar,
              private api: ApiService,
              public http: HttpClient,
              public iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer) {

    snackBar.dismiss();

    iconRegistry.addSvgIcon(
      'prescription',
        sanitizer.bypassSecurityTrustResourceUrl('assets/prescription.svg'));

    this.eventSubject.subscribe(e => {
      this.events.push(e);
      console.log("Publishing " + this.events.length + " events...");
      this.schedulerSubject.next(this.events);
    });

  }


  public ngOnInit(): void {
    this.getAppointments();
  }

  public ngOnDestroy(): void {

  }

  public sendTelehealthInvitation() {
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      disableClose: true,
      data: {},
      width: '750px'
    });

    dialogRef.afterClosed().subscribe(appointment => {

      if (appointment) {
        if( appointment.invitation ) {
          this.api.post<any>(`/appointment`, appointment).subscribe(result => {
            this.snackBar.open('Invitation Sent', null, {
              duration: 2000
            });
            this.getAppointments();
            this.userContext.fetchRequests();
          }, (error) => {
            this.snackBar.open(`Error sending invitation: ${error}`, null, {
              duration: 2000
            });
          });
        } else {
          this.api.post<any>(`/client/${(this.client.id)}/appointment`, appointment).subscribe(result => {
            this.snackBar.open('Invitation Sent', null, {
              duration: 2000
            });
            this.getAppointments();
            this.userContext.fetchRequests();
          }, (error) => {
            this.snackBar.open(`Error sending invitation: ${error}`, null, {
              duration: 2000
            });
          });
        }
      }
    });
  }


  public appointmentsStateChange(state: DataStateChangeEvent): void {
    this.appointmentsState = state;
    this.appointments = {
      data: (this.appointments || []).slice(this.appointmentsState.skip, this.appointmentsState.skip + this.appointmentsState.take),
      total: (this.appointments || []).length
    };
  }

  public doubleClickedEvent(event: EventClickEvent) {
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      disableClose: true,
      data: event.event,
      width: '750px'
    });

    dialogRef.afterClosed().subscribe(appointment => {

      if (appointment) {
        if( appointment.cancel ) {
          this.api.del<any>(`/appointment/${appointment.id}`, appointment).subscribe(result => {
            this.snackBar.open('Appointment Canceled', null, {
              duration: 2000
            });
            this.getAppointments();
          }, (error) => {
            this.snackBar.open(`Error cancelling appointment: ${error}`, null, {
              duration: 2000
            });
          });
        } else {
          console.log("Will update appointment: " + JSON.stringify(appointment, null, 4));
          this.api.patch<any>(`/appointment/${appointment.id}`, appointment).subscribe(result => {
            this.snackBar.open('Appointment Updated', null, {
              duration: 2000
            });
            this.getAppointments();
          }, (error) => {
            this.snackBar.open(`Error updating appointment: ${error}`, null, {
              duration: 2000
            });
          });
        }
      }
    });
  }

  public getAppointments() {
    console.log("Getting appoints from : " + JSON.stringify(this.userContext.user,null,4));
    this.events = [];
    this.api.get(`/account/${(this.userContext.account.id)}/appointment`).subscribe(appointmentResult => {
      this.appointments = appointmentResult;
      this.userContext.appointments = this.appointments;
      this.userContext.appointmentsObserver.next(this.appointments);
      (this.appointments || []).forEach( a => {
        this.eventSubject.next(<SchedulerEvent> {
          title: a.type || "Appointment",
          subject: a.subject,
          id: a.id,
          type: a.type,
          invitation: a.invitation,
          confirmed: a.confirmed,
          location_id: a.location_id,
          account_id: a.account_id,
          name: a.name,
          user_id: a.user_id,
          client_id: a.client_id,
          duration: a.duration || 30,
          providerName: a.providerName,
          when: a.when,
          description: `${a.type || ""} Appointment`,
          start: moment(a.when).toDate(),
          end: moment(a.when).add(a.duration || 30, 'minutes').toDate()
        });
      });
    }, (error) => {
      console.log('Error getting appointments ' + JSON.stringify(error));
    });
  }

  public onAppointmentSelection(event: SelectionEvent) {
    this.selectedAppointment = event.selectedRows[0];
  }

}
